<script setup>
import { ref, defineProps, computed, watch } from 'vue';

const props = defineProps({
    value: [String, Number],
    setValue: Function,
    disabled: Boolean,
    error: Boolean,
});


const addValue = (number) => {
    const _result = (parseFloat(props.value) || 0) + number;
    if (_result <= 0.00) {
        props.setValue('1.00');
    } else if (_result >= 100.00) {
        props.setValue('100.00');
    } else {
        props.setValue(_result + '.00');
    }
}

// const inputText = (e)=>{
// console.log(e.target.value);
// const _value =  e.target.value;
// const _result = parseInt(_value || 0);
// if (_result <= 0) {
//     props.setValue('0%');
// } else if (_result >= 100) {
//     props.setValue('100%');
// } else {
//     props.setValue(_result + '%');
// }
// }


let timeOut;
const inputText = (e) => {
    timeOut = setTimeout(() => {
        const _value = parseFloat(e.target.value).toFixed(2);
        let _temp = '0.00';
        if (_value <= 0.00 || _value == NaN || _value == 'NaN') {
            _temp = '1.00';
        } else if (_value > 100.00) {
            _temp = '100.00';
        }else {
            _temp = (_value + '' || '0.00');
        }
        e.target.value = _temp;
        props.setValue(_temp);
    }, 800);
}

const checkText = (e) => {
    const nextVal = 
        e.target.value.substring(0, e.target.selectionStart) +
        (e.data ?? '') +
        e.target.value.substring(e.target.selectionEnd)
    ;
    console.log(nextVal)
    if(!/^([0-9]*)(\.{0,1})([0-9]*)$/.test(nextVal)) {
        e.preventDefault();
    }
    return;
}

// const inputBlur = (e) => {
//     props.setValue((parseInt(e.target.value) || 0) + '%');
// }


</script>

<template>
    <div>
        <div class="relative">
            <button class="px-3 absolute top-0 bottom-0 left-0" v-show="!(disabled)" @click="(e) => { addValue(-5) }">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 12H2.99981" stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>
            
            <input class="text-center" :class="{ 'border-[#EB4751]': error }" type='text' :value="value"
                @beforeinput="checkText"
                @input="inputText" maxlength='6' pattern="[0-9]*" :disabled="disabled" />
            <div class="units" v-show="!(disabled)">%</div>

            <button class="px-3 absolute top-0 bottom-0 right-0" v-show="!(disabled)" @click="(e) => { addValue(5) }">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 3V21.0002" stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                    <path d="M21 12H2.99982" stroke="#0093C1" stroke-width="2" stroke-linecap="round"
                        stroke-linejoin="round" />
                </svg>
            </button>

        </div>
        <div class="text-[#EB4751] pt-2 text-sm" v-show="error">所有受益人比例相加需為 100%</div>
    </div>
</template>

<style scoped>
.units {
    position: absolute;
    top: 13px;
    left: 76px;
    right: 0;
    bottom: 0;
    pointer-events: none;
    overflow: hidden;
    text-align: center;
}
</style>
